import { render, staticRenderFns } from "./ReqTrasladoFormComponent.vue?vue&type=template&id=7e0717e9&scoped=true&"
import script from "./ReqTrasladoFormComponent.vue?vue&type=script&lang=js&"
export * from "./ReqTrasladoFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReqTrasladoFormComponent.vue?vue&type=style&index=0&id=7e0717e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0717e9",
  null
  
)

export default component.exports